"use strict";
exports.__esModule = true;
exports.post = exports.get = void 0;
var tslib_1 = require("tslib");
var cross_fetch_1 = (0, tslib_1.__importDefault)(require("cross-fetch"));
var utils_1 = require("./utils");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var get = function (url, options) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var response, json;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (options === null || options === void 0 ? void 0 : options.params) {
                    url = (0, utils_1.createUrl)(url, options.params);
                }
                return [4 /*yield*/, (0, cross_fetch_1["default"])(url, {
                        method: "GET",
                        headers: options === null || options === void 0 ? void 0 : options.headers
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                json = (_a.sent());
                return [2 /*return*/, json];
        }
    });
}); };
exports.get = get;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var post = function (url, options) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var headers, body, response, json;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (options === null || options === void 0 ? void 0 : options.params) {
                    url = (0, utils_1.createUrl)(url, options.params);
                }
                headers = (0, utils_1.createHeaders)({
                    headers: options === null || options === void 0 ? void 0 : options.headers,
                    type: options === null || options === void 0 ? void 0 : options.type
                });
                body = (0, utils_1.createBody)({ body: options === null || options === void 0 ? void 0 : options.body, type: options === null || options === void 0 ? void 0 : options.type });
                return [4 /*yield*/, (0, cross_fetch_1["default"])(url, {
                        method: "POST",
                        headers: headers,
                        body: body
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                json = (_a.sent());
                return [2 /*return*/, json];
        }
    });
}); };
exports.post = post;
//# sourceMappingURL=http.js.map